import { LoggedInUser } from 'common/user-context'
import { isAdmin, isCallcenter, isEmployee } from 'common/utils'

export { getMostImportantRole } from './getMostImportantRole'
export { formatAddress } from './formatAddress'
export { getVisitedRecently } from './getVisitedRecently'

export const canCancelWithReason = (user?: LoggedInUser): boolean =>
  !!user && (isAdmin(user) || isEmployee(user) || isCallcenter(user))
